import { EnableWhen, ValidationObject } from 'src/interfaces/utility-interfaces';

import { BaseInput } from './base-input';

export class DateTimeInput extends BaseInput<Date> {
  controlType = 'dateTimePicker';
  placeholder: string;
  allowUnknown: boolean;
  allowNotApplicable: boolean;
  dateTimeErrorMsg: string;

  constructor(
    options: {
      value?: Date,
      placeholder?: string,
      allowUnknown?: boolean,
      allowNotApplicable?: boolean,
      linkId?: string,
      label?: string,
      required?: boolean,
      controlType?: string,
      enableWhen?: EnableWhen[],
      show?: boolean,
      readonly?: boolean,
      validation?: ValidationObject,
      related?: string,
      dateTimeErrorMsg?: string,
      dataMissingReason?: string
    } = {}
  ) {
    super(options);
    this.placeholder = options.placeholder || '';
    this.dateTimeErrorMsg = options.dateTimeErrorMsg || '';
    this.allowUnknown = options.allowUnknown || false;
    this.allowNotApplicable = options.allowNotApplicable || false;
  }
}
